import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b0221c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "veil",
  class: "MobileMenu__Veil"
}
const _hoisted_2 = {
  ref: "background",
  class: "MobileMenu__Background"
}
const _hoisted_3 = { class: "MobileMenu__Scroller" }
const _hoisted_4 = {
  ref: "inner",
  class: "MobileMenu__Inner"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "MobileMenu" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "MobileMenu__Footer" }
const _hoisted_9 = { class: "MobileMenu__Socials" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 11 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-facebook" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 16" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-twitter" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-instagram" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-tiktok" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LangChooser = _resolveComponent("LangChooser")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "menu",
    onEnter: _cache[0] || (_cache[0] = (el, done) => _ctx.onEnter(done)),
    onLeave: _cache[1] || (_cache[1] = (el, done) => _ctx.onLeave(el, done)),
    mode: "in-out"
  }, {
    default: _withCtx(() => [
      (_ctx.MenuMobileStore.isOpen)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 0,
            class: "MobileMenu__Nav",
            style: _normalizeStyle({ height: _ctx.Viewport.windowHeight + 'px' }),
            ref: "nav"
          }, [
            _createElementVNode("div", _hoisted_1, null, 512),
            _createElementVNode("div", _hoisted_2, null, 512),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.allowLang)
                  ? (_openBlock(), _createBlock(_component_LangChooser, {
                      key: 0,
                      class: "MobileMenu__LangChooser"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5)),
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: 'mobile-menu-item--'+index
                    }, [
                      (item.to)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: item.to,
                            class: _normalizeClass(item.class),
                            onClick: _ctx.onClickItem
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(item.i18n)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class", "onClick"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: item.href,
                            class: _normalizeClass(item.class)
                          }, _toDisplayString(_ctx.$t(item.i18n)), 11, _hoisted_7))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("footer", null, [
                  _createElementVNode("ul", _hoisted_8, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/company",
                        onClick: _ctx.onClickItem
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('footer.company')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/contact",
                        onClick: _ctx.onClickItem
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('footer.contact')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/faq",
                        onClick: _ctx.onClickItem
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('footer.faqs')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.$t('footer.facebook'),
                        target: "_blank",
                        class: "MobileMenu__Socials__Link MobileMenu__Socials__Link--Facebook"
                      }, _hoisted_12, 8, _hoisted_10)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.$t('footer.twitter'),
                        target: "_blank",
                        class: "MobileMenu__Socials__Link MobileMenu__Socials__Link--Twitter"
                      }, _hoisted_15, 8, _hoisted_13)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.$t('footer.instagram'),
                        target: "_blank",
                        class: "MobileMenu__Socials__Link MobileMenu__Socials__Link--Instagram"
                      }, _hoisted_18, 8, _hoisted_16)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.$t('footer.tiktok'),
                        target: "_blank",
                        class: "MobileMenu__Socials__Link MobileMenu__Socials__Link--Tiktok"
                      }, _hoisted_21, 8, _hoisted_19)
                    ])
                  ])
                ])
              ], 512)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}